import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appAlphaNumeric]'
})
export class AlphaNumericDirective {
    constructor(private el: ElementRef) { }

    @HostListener('input', ['$event']) onInput(event: Event): void {
        const inputElement = this.el.nativeElement as HTMLInputElement;
        const inputValue: string = inputElement.value;
        // Allow only alphabetic and numeric characters, removing special characters
        const alphaNumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
        inputElement.value = alphaNumericValue;
    }
}
